import IntlTelInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const DEFAULT_COUNTRY = 'us';

const PhoneInput = ({
    value,
    onChange,
    onBlur,
    required,
    label,
    errorMessage,
    disabled,
    country,
    placeholder,
    name,
    countryCode,
    className,
    ...rest

}) => {
    return (
        <IntlTelInput
            // containerClassName="intl-tel-input"
            // inputClassName="form-control"
            value={value}
            onChange={(value) => {
                onChange(value);
            }}
            // placeholder={placeholder}
            // fieldName={name}
            country={DEFAULT_COUNTRY}
            countryCodeEditable
            disabled={disabled}
            // inputClass={className}
            containerclassName=""
            containerStyle={{
                borderRadius: 10
            }}
            dropdownStyle={{
                borderRadius: 10

            }}
            
            
            
            inputProps={{
                required,
                disabled,
                name,
                type: 'tel',
                className,
                style: disabled ? { backgroundColor: "#f1f5f9", cursor: "not-allowed" } : undefined,
                
                
            }}
         

            // inputClassName={className}
            // separateDialCode={true} // Optional: shows country code separately
            // style={{
                // width: "100%",
            // }}
            // input
            // type="tel"
            // containerClassName="intl-tel-input" // Optional styling classes
            // inputClassName="form-control" // Optional input styling
            

        />
    )
}

export default PhoneInput